export const PREVIEW_KEY = 'serviti_pending_business_preview';

export function pendingPreview() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(PREVIEW_KEY));
    return typeof saved?.token === 'string' && saved.token.length <= 2048 && saved.until > Date.now() ? saved : null;
  } catch { return null; }
}
